export const patternsValidators = {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^(\([1-9]{2}\)\s?)?[0-9]{4,5}-?[0-9]{4}$/,
    dateOfBirth: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
    password: /^(?!.*(.)\1)(?!.*(01|12|23|34|45|56|67|78|89))\d+$/,
    cpf: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
};

export const creditFormEnum = {
    bankTransfer: { id: 2, name: 'Transferência Bancária' },
    BMGAccount: { id: 18, name: 'Conta BMG' },
}

export const typeCardEnum = {
    master: 'MASTER',
    bmg: 'BMG',
    benefit: 'BENEFIT'
}

export const isValidCPF = (cpf) => {
    // Remove tudo que não for número
    cpf = cpf.replace(/[^\d]+/g, '');

    if (cpf.length !== 11) return false;

    // Elimina CPFs com todos os dígitos iguais (ex: 111.111.111-11)
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    let remainder;

    // Valida o primeiro dígito verificador
    for (let i = 1; i <= 9; i++) {
        sum += parseInt(cpf.charAt(i - 1)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) return false;

    // Valida o segundo dígito verificador
    sum = 0;
    for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf.charAt(i - 1)) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) return false;

    return true;
}